import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const LABEL = {
  delivered: ["Zugestellt", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  opened: ["Geöffnet", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  clicked: ["Geöffnet", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  sent: ["Unterwegs", "bg-amber-50 text-amber-800 border-amber-300"],
  queued: ["Unterwegs", "bg-amber-50 text-amber-800 border-amber-300"],
  scheduled: ["Geplant", "bg-amber-50 text-amber-800 border-amber-300"],
  delivery_delayed: ["Verzögert", "bg-amber-100 text-amber-900 border-amber-400"],
  bounced: ["Unzustellbar", "bg-red-100 text-red-800 border-red-300"],
  failed: ["Nicht versendet", "bg-red-100 text-red-800 border-red-300"],
  complained: ["Als Spam markiert", "bg-red-100 text-red-800 border-red-300"],
  disabled: ["Nicht versendet", "bg-slate-100 text-slate-600 border-slate-300"],
};
const lab = (s) => LABEL[s] || ["Unbekannt", "bg-slate-100 text-slate-600 border-slate-300"];
const dt = (iso) => (iso ? new Date(iso).toLocaleString("de-DE", { dateStyle: "short", timeStyle: "short" }) : "—");

function Line({ item, title }) {
  const [l, cls] = lab(item.status);
  return (
    <div className="py-2 border-b border-slate-100 last:border-0 text-xs">
      <div className="flex items-center justify-between gap-2">
        <span className="font-medium text-slate-900">{title}</span>
        <span className={`px-1.5 py-0.5 border text-[10px] font-bold ${cls}`}>{l}</span>
      </div>
      <div className="text-slate-600 mt-1">An: <span className="font-mono">{item.to}</span></div>
      <div className="text-slate-600">CC: <span className="font-mono">{item.cc?.length ? item.cc.join(", ") : "nicht protokolliert"}</span></div>
      <div className="text-slate-400 mt-0.5">gesendet {dt(item.sent_at)}{item.checked_at ? ` · geprüft ${dt(item.checked_at)}` : ""}</div>
    </div>
  );
}

export default function InvoiceDeliveryBadge({ invoiceId, info }) {
  if (!info?.main) return null;
  const [l, cls] = lab(info.main.status);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className={`px-1.5 py-0.5 border text-[10px] font-bold uppercase tracking-overline ${cls}`} data-testid={`mgmt-invoice-delivery-${invoiceId}`}>
          {l}{info.copies.length > 0 ? ` · ${info.copies.length} Kopie${info.copies.length > 1 ? "n" : ""}` : ""}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-96 rounded-none p-4" data-testid={`mgmt-invoice-delivery-pop-${invoiceId}`}>
        <div className="text-[10px] font-bold uppercase tracking-overline text-slate-500 mb-1">Zustellstatus</div>
        <Line item={info.main} title="E-Mail an Jobcenter + CC (gemeinsamer Status)" />
        {info.copies.map((c, i) => <Line key={i} item={c} title={`Erneut gesendet (Kopie) an ${c.to}`} />)}
      </PopoverContent>
    </Popover>
  );
}
